import React, { useState, useEffect } from "react";
import TotalNoCard from "../../components/TotalNoCard/TotalNoCard";
import { BaseStationStyle } from "./BaseStation.styled";
import { useNavigate } from "react-router-dom";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getActiveBeaconCountStatus,
  getActiveBeaconCountStatus1,
  getBaseStationData,
  getBaseStationWarranty,
  getLatestBaseStationRecords,
} from "../../api/BaseStationApi";
import PercentageCard from "../../components/PercentageCard/PercentageCard";
import DeleteButton from "../../components/Buttons/DeleteButton";
import { toast } from "react-toastify";
import moment from "moment/moment";
import { checkStatusExpiry } from "../../common/checkStatusExpiry";
import Card2 from "../../components/Card2/Card2";
import { useDB } from "../../context/DynamoDBContext";
import { useReload } from "../../context/ReloadContext";
import StatusEnum from "../../common/StatusEnum";
import { CacheTime, StaleTime } from "../../common/StaleTime";
import Internet from "../../components/internet/Internet";
import DeleteStatus from "../../components/internet/DeleteStatus";
import useInternetConnectivity from "../../hooks/useInternetConnectivity";
import { useDispatch, useSelector } from "react-redux";
import ExportData from "../../components/Export/ExportData";
import BaseStationChart from "../../components/baseStationCharts/BaseStationChart";
import NoDataChart from "../../components/NoDataChart/NoDataChart";
import Popup from "../../components/Modals/Modal";
import api from "../../api/configAxios";
import Controller from "../../common/controller";
import {
  getTreeData1API,
  getTreeData2API,
  getTreeData3API,
} from "../../api/NavBarApi";
import { setTreeDataRed } from "../../redux/TreeData/TreeDataSlice";
import { capitalizeFirstLetter } from "../../common/capitalizeFirstLetter";
import { PageStyle } from "../../styles/MainBodyStyles";

const BaseStation = ({ title, id, email }) => {
  const { dynamoDBClient } = useDB();
  const dispatch = useDispatch();
  const isOnline = useInternetConnectivity();
  const navigateRed = useSelector((state) => state.navigateRed);
  const { access_token } = useSelector((state) => state.userKeyRed);
  const { reload, setReload } = useReload();
  const queryClient = useQueryClient();
  const [enableBaseStaionAPI, setEnableBaseStaionAPI] = useState(false);
  const [enableBaseStaionAPI2, setEnableBaseStaionAPI2] = useState(false);
  const [activeBeacons, setActiveBeacons] = useState("0");
  const [userBSStatus, setUserBSStatus] = useState("No Data");
  const [userBSLocation, setUserBSLocation] = useState("Not Available");
  const [userBSMac, setUserBSMac] = useState("xxxxxxxxx");
  const [isDelete, setIsDelete] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [record, setRecord] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [userWifi, setUserWifi] = useState("Not Available");
  const [userQR, setUserQR] = useState("Not Available");
  const [userFirmWare, setUserFirmWare] = useState("Not Available");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [tableHistoryStatus, setTableHistoryStatus] = useState("Loading ... ");
  const [warranty, setWarranty] = useState("...");
  const [beaconCounts, setBeaconCounts] = useState({
    online: 0,
    offline: 0,
    snoozed: 0,
  });
  const [beaconPercentage, setBeaconPercentage] = useState({
    online: 0,
    offline: 0,
    snoozed: 0,
  });

  useEffect(() => {
    setConfirmDelete(false);
    setIsDelete(false);
  }, [id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (reload) {
      queryClient.fetchQuery(["BaseStationDataAPI", id]);
      queryClient.fetchQuery(["ActiveBeaconCount1", id]);
      queryClient.fetchQuery(["LatestBaseStationRecord", id]);
    }
  }, [reload]);

  useEffect(() => {
    if (dynamoDBClient !== null) {
      setEnableBaseStaionAPI(true);
    } else {
      setEnableBaseStaionAPI(false);
    }
  }, [dynamoDBClient]);

  const handleError = (type) => {
    if (type === "LatestBaseStationRecord") {
      toast.error("Error While Fetching BaseStation Notifications", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "BaseStationDataAPI") {
      toast.error("Unable to get BaseStation Data", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
    if (type === "ActiveBeaconCount2" || type === "ActiveBeaconCount1") {
      toast.error("Unable to get Active Beacon Data", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const setBaseStationData = (data = []) => {
    if (data.length !== 0) {
      const info = data[0];
      // setUserEmail(info.Email)
      setUserBSMac(info.GatewayMAC);
      const word = capitalizeFirstLetter(info.status);
      setUserBSStatus(word);
      setUserQR(info.QRCode);
      // setUserFirmWare(info.Firmware)
      let ssid = "";
      if (typeof info.WifiSettings === "string") {
        setUserWifi("Not Available");
      } else {
        const jsonData = JSON.parse(info.WifiSettings);
        ssid = jsonData.SSID;
        setUserWifi(ssid);
      }
      setUserBSLocation(info.GatewayLocation ? info.GatewayLocation : title);
    }
  };

  const { data: baseStationData } = useQuery({
    queryKey: ["BaseStationDataAPI", id],
    queryFn: () => getBaseStationData(dynamoDBClient, id, email),
    enabled: enableBaseStaionAPI,
    onSuccess: (data = []) => {
      if (data.length > 0) {
        setBaseStationData(data);
      } else {
        setConfirmDelete(true);
        setIsDelete(true);
      }
    },
    onError: (error) => {
      console.log("BaseStationDataAPI :", error);
      setEnableBaseStaionAPI(false);
      handleError("BaseStationDataAPI");
    },
  });

  const deleteGateway = async () => {
    setIsDelete(true);
    try {
      var response = await api.post(
        `${Controller.dynamoDB}/deleteGateway`,
        {
          email: email.toLocaleLowerCase(),
          mac: id,
        },
        {
          headers: {
            Authorization: "Bearer " + access_token,
          },
        }
      );
      toast("BaseStation Deleted Successfully. Refresh Tree");
      setIsDelete(true);
      setConfirmDelete(true);
      setReload();
    } catch (error) {
      setIsDelete(false);
      toast.error("Unable to delete BaseStation", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const calculateRecordData = (data = []) => {
    if (data.length !== 0) {
      setRecord(data);
    } else {
      setRecord([]);
      setTableHistoryStatus("No History Available");
    }
  };

  const { status: recordStatus, data: recordData } = useQuery({
    queryKey: ["LatestBaseStationRecord", id],
    queryFn: () => getLatestBaseStationRecords(dynamoDBClient, id, email),
    enabled: enableBaseStaionAPI,
    onSuccess: (data = []) => {
      calculateRecordData(data);
    },
    onError: (error) => {
      console.log("Error While Fetching BaseStation Notifications: ", error);
      handleError("LatestBaseStationRecord");
    },
  });

  const { status: warrantyStatus, data: warantyData } = useQuery({
    queryKey: ["BaseStationWarranty", id],
    queryFn: () => getBaseStationWarranty(dynamoDBClient, id),
    enabled: enableBaseStaionAPI,
    onSuccess: (data = []) => {},
  });

  const roundDecimal = (number, total) => {
    const percentage = (number / total) * 100;
    const decimalPart = percentage % 1;
    if (decimalPart > 0) {
      return decimalPart > 0.5 ? Math.ceil(number) : Math.floor(number);
    } else {
      return Math.round(percentage);
    }
  };

  const calculateBeaconData = (data = []) => {
    const total = data.length;
    setActiveBeacons(total);
    const beaconStatusCounts = {
      online: 0,
      offline: 0,
      snoozed: 0,
    };
    if (data.length !== 0) {
      data.forEach((item) => {
        const beaconStatus = item.BeaconStatus;
        if (beaconStatus === StatusEnum.online) {
          const isGreaterTime = checkStatusExpiry(item.DateUpdated);

          if (isGreaterTime) {
            beaconStatusCounts[StatusEnum.offline]++;
          } else {
            beaconStatusCounts[StatusEnum.online]++;
          }
        } else {
          beaconStatusCounts[beaconStatus]++;
        }
      });
      setBeaconPercentage({
        online: roundDecimal(beaconStatusCounts.online, total),
        offline: roundDecimal(beaconStatusCounts.offline, total),
        snoozed: roundDecimal(beaconStatusCounts.snoozed, total),
      });

      setBeaconCounts(beaconStatusCounts);
    } else {
      setBeaconCounts(beaconStatusCounts);
      setBeaconPercentage({
        online: 0,
        offline: 0,
        snoozed: 0,
      });
    }
  };

  const { data: extra } = useQuery({
    queryKey: ["ActiveBeaconCount1", id],
    queryFn: () => getActiveBeaconCountStatus1(dynamoDBClient, id, email),
    enabled: enableBaseStaionAPI,
    onSuccess: (data) => {
      if (data) {
        setEnableBaseStaionAPI2(true);
        queryClient.fetchQuery(["ActiveBeaconCount2", id], {
          queryFn: () =>
            getActiveBeaconCountStatus(dynamoDBClient, email, extra),
        });
      } else {
        setActiveBeacons(0);
        setBeaconCounts({
          online: 0,
          offline: 0,
          snoozed: 0,
        });
        setBeaconPercentage({
          online: 0,
          offline: 0,
          snoozed: 0,
        });
      }
    },
    onError: (error) => {
      console.log("ActiveBeaconCount1 :", error);
      setEnableBaseStaionAPI(false);
      handleError("ActiveBeaconCount1");
    },
  });
  const { data: activeBCountData } = useQuery({
    queryKey: ["ActiveBeaconCount2", id],
    queryFn: () => getActiveBeaconCountStatus(dynamoDBClient, email, extra),
    enabled: enableBaseStaionAPI2,
    onSuccess: (data = []) => {
      if (data.length > 0) {
        calculateBeaconData(data);
      } else {
        setActiveBeacons(0);
        setBeaconCounts({
          online: 0,
          offline: 0,
          snoozed: 0,
        });
        setBeaconPercentage({
          online: 0,
          offline: 0,
          snoozed: 0,
        });
      }
    },
    onError: (error) => {
      console.log("ActiveBeaconCount2 :", error);
      setEnableBaseStaionAPI2(false);
      handleError("ActiveBeaconCount2");
    },
  });

  useEffect(() => {
    if (baseStationData) {
      setBaseStationData(baseStationData);
    }

    if (recordData) {
      calculateRecordData(recordData);
    }

    if (activeBCountData) {
      calculateBeaconData(activeBCountData);
    }
  }, [baseStationData, recordData, activeBCountData]);

  return (
    <BaseStationStyle>
      <PageStyle>
        <ExportData />
        <Popup
          title="Delete Base Station"
          visible={showModal}
          setVisible={() => setShowModal(false)}
          message={
            "This Action will DELETE the BaseStation. Are you sure you want to proceed?"
          }
          onAccept={() => {
            setShowModal(false);
            deleteGateway();
          }}
        />
        <div
          className={navigateRed.sideBar ? "home-container" : "home-container2"}
        >
          {!isOnline && <Internet />}

          {confirmDelete && <DeleteStatus />}
          <HeadingStyle>{title}</HeadingStyle>
          <div className="main">
            <TotalNoCard heading={"Status"} total={userBSStatus} />
            <TotalNoCard heading={"Location"} total={userBSLocation} />
            <TotalNoCard heading={"WiFi Network & Settings"} total={userWifi} />
            <TotalNoCard heading={"QR Code"} total={userQR} />
            <TotalNoCard heading={"MAC Number"} total={userBSMac} />
            {/* <TotalNoCard heading={"Warranty"} total={warranty} /> */}
          </div>
          <HeadingStyle>
            System&ensp;<i className="bi bi-clipboard2-data heading-icon"></i>
          </HeadingStyle>

          <div className="main">
            <PercentageCard
              heading={"Total No of Active Beacons"}
              total={activeBeacons}
            />

            <Card2
              heading={
                "Total No & Percentage of Active Beacons Reporting Online"
              }
              total={`${beaconCounts.online}`}
              percentage={`${beaconPercentage.online}%`}
            />
            <Card2
              heading={
                "Total No & Percentage of Active Beacons Reporting Offline"
              }
              total={`${beaconCounts.offline}`}
              percentage={`${beaconPercentage.offline}%`}
            />
            <Card2
              heading={
                "Total No & Percentage of Active Beacons Reporting Snooze"
              }
              total={`${beaconCounts.snoozed}`}
              percentage={`${beaconPercentage.snoozed}%`}
            />
          </div>

          <HeadingStyle>
            History&ensp;<i className="bi bi-table heading-icon"></i>
          </HeadingStyle>
          <div className="table-div">
            <table className="table table-hover">
              <thead className="table-head">
                <tr>
                  <th scope="col" className="table-item">
                    #
                  </th>
                  <th scope="col" className="table-item">
                    Device TimeStamp
                  </th>
                  <th scope="col" className="table-item">
                    Notification TimeStamp
                  </th>
                  <th scope="col" className="table-item">
                    Notification
                  </th>
                </tr>
              </thead>
              <tbody>
                {recordStatus === "loading" ? (
                  <tr>
                    <td colSpan={4}>
                      <p className="table-loading">Loading...</p>
                    </td>
                  </tr>
                ) : record.length === 0 ? (
                  <tr>
                    <td colSpan={4}>
                      <p className="table-loading">{tableHistoryStatus}</p>
                    </td>
                  </tr>
                ) : (
                  record.map((item, index) => {
                    const formattedNotification = moment
                      .utc(item.NotificationTimeStamp)
                      .local()
                      .format("YYYY-MM-DD h:mm:ss A");
                    let formattedDeviceTime;
                    if (item.RecordTimeStamp) {
                      formattedDeviceTime = moment
                        .utc(item.RecordTimeStamp)
                        .local()
                        .format("YYYY-MM-DD h:mm:ss A");
                    } else {
                      formattedDeviceTime = moment
                        .utc(item.NotificationTimeStamp)
                        .local()
                        .format("YYYY-MM-DD h:mm:ss A");
                    }
                    return (
                      <tr key={index}>
                        <th scope="row" className="table-item">
                          {index + 1}
                        </th>
                        <td className="table-item2">{formattedDeviceTime}</td>
                        <td className="table-item2">{formattedNotification}</td>
                        <td className="table-item2">
                          {item.NotificationReason}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
          <DeleteButton
            btnText="DELETE BASE STATION"
            disabled={isDelete}
            onClick={() => {
              setShowModal(true);
            }}
          />
        </div>
      </PageStyle>
    </BaseStationStyle>
  );
};

export default BaseStation;
